import moment from 'moment';
import http from '../../utils/httpClient';
import router from '../../router';

const state = {
  drivingGameList: [],
  selectedDrivingGame: {},
  createDrivingGame: {},
  updateDrivingGame: {},
  isLoadDrivingGame: true,
  defaultCreate: {
    category_id: '',
    title: '',
    items_info: [
      {
        word: '',
        image_uri: '',
        // hit_audio_uri: '',
        scale: '0',
        voice_name: '',
        tts_message: '',
      },
    ],
    character: 0,
    theme: 0,
    correct_count: 0,
    // sound_correct_uri: '',
    bgm_uri: '',
    bgm_volume: '0.5',
  },
};
const getters = {};
const actions = {
  fetchDrivingCategory({ commit, dispatch }, { page = 1, limit = 0 }) {
    const query = {
      params: { page, limit },
    };
    return http
      .GET(`/api/driving_game/category`, {
        option: query,
        isAuthorization: true,
      })
      .then(({ data }) => {
        const formatData = data.map(e => ({
          ...e,
          created_at: moment(e.created_at).format('MMMM D YYYY h:mm a'),
          updated_at: moment(e.updated_at).format('MMMM D YYYY h:mm a'),
        }));
        dispatch('clearAllState');
        dispatch('setStateByKey', {
          statekey: 'drivingGameList',
          value: formatData,
        });
      })
      .catch(err => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message:
              'Cannot fetch driving game in this time. please try again.',
            type: 'error',
          },
          {
            root: true,
          },
        );
        throw new Error(err);
      })
      .finally(() => {
        dispatch('setStateByKey', {
          statekey: 'isLoadDrivingGame',
          key: null,
          value: false,
        });
      });
  },
  fetchDrivingGameList(
    { commit, dispatch },
    { id, game_list_id, category_id },
  ) {
    const url = id ? `/api/driving_game` : `/api/driving_game/category`;
    const query = {
      params: game_list_id
        ? { id: game_list_id }
        : category_id
        ? { category_id }
        : { id, isWeb: true },
    };
    return http
      .GET(url, {
        option: query,
        isAuthorization: true,
      })
      .then(({ data }) => {
        const [formatData] = data.map(e => {
          const driving_game = e.driving_games.map(data => {
            return {
              ...data,
              created_at: moment(data.created_at).format('MMMM D YYYY h:mm a'),
              updated_at: moment(data.updated_at).format('MMMM D YYYY h:mm a'),
            };
          });
          e.driving_games = driving_game;
          return { ...e };
        });
        dispatch('clearAllState');
        dispatch('setStateByKey', {
          statekey: 'drivingGameList',
          value: formatData,
        });
      })
      .catch(err => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message:
              'Cannot fetch driving game in this time. please try again.',
            type: 'error',
          },
          {
            root: true,
          },
        );
        throw new Error(err);
      })
      .finally(() => {
        dispatch('setStateByKey', {
          statekey: 'isLoadDrivingGame',
          key: null,
          value: false,
        });
      });
  },
  createDrivingGame({ commit, dispatch }, createData) {
    createData = createData ? createData : state.createDrivingGame;
    http
      .POST(`/api/driving_game`, createData, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        if (state.drivingGameList._id) {
          dispatch('fetchDrivingGameList', {
            game_list_id: state.drivingGameList._id,
          });
        } else {
          router.go({
            path: '/driving_game',
          });
          dispatch('fetchDrivingCategory', {
            page: 1,
            limit: 0,
          });
        }
        dispatch(
          'appConfig/toggleAlert',
          {
            type: 'success',
            message: 'Create driving game successfully',
          },
          {
            root: true,
          },
        );
      })
      .catch(err => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message:
              'Cannot create driving game in this time. please try again.',
            type: 'error',
          },
          {
            root: true,
          },
        );
        throw new Error(err);
      });
  },
  deleteDrivingGame({ commit, dispatch }, id) {
    http
      .DELETE(`/api/driving_game?id=${id}`, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        dispatch('clearStateByKey', 'updateDrivingGame');
        dispatch('fetchDrivingGameList', {
          game_list_id: state.drivingGameList._id,
        });
        dispatch(
          'appConfig/toggleAlert',
          {
            type: 'success',
            message: 'Delete driving game successfully',
          },
          {
            root: true,
          },
        );
      })
      .catch(err => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message:
              'Cannot delete runnung game in this time. please try again.',
            type: 'error',
          },
          {
            root: true,
          },
        );
        throw new Error(err);
      });
  },
  updateDrivingGame({ commit, dispatch }, updateData) {
    updateData = updateData ? updateData : state.updateDrivingGame;
    delete updateData.created_at;
    delete updateData.updated_at;
    delete updateData.game_list_id;
    http
      .PUT(`/api/driving_game`, updateData, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        dispatch('fetchDrivingGameList', {
          game_list_id: state.drivingGameList._id,
        });
        dispatch(
          'appConfig/toggleAlert',
          {
            type: 'success',
            message: 'Update driving game successfully',
          },
          {
            root: true,
          },
        );
      })
      .catch(err => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message:
              'Cannot update driving game in this time. please try again.',
            type: 'error',
          },
          {
            root: true,
          },
        );
        throw new Error(err);
      });
  },
  setStateByKey({ commit }, { statekey, key, value }) {
    commit('set_state_by_key', { statekey, key, value });
  },
  clearStateByKey({ commit }, statekey) {
    commit('clear_state_by_key', statekey);
  },
  clearAllState({ commit }) {
    commit('clear_all_state');
  },
};
const mutations = {
  set_state_by_key(state, { statekey, key, value }) {
    if (Array.isArray(state[statekey])) {
      state[statekey] = value;
    } else {
      switch (typeof state[statekey]) {
        case 'object':
          key
            ? (state[statekey] = { ...state[statekey], [key]: value })
            : (state[statekey] = { ...value });
          break;
        default:
          state[statekey] = value;
      }
    }
  },
  clear_state_by_key(state, statekey) {
    state[statekey] = ClearType(state[statekey], true);
  },
  clear_all_state(state) {
    for (const [key, value] of Object.entries(state)) {
      if (!key.includes('default')) {
        if (Array.isArray(value)) {
          state[key] = [];
        } else state[key] = ClearType(value);
      }
    }
  },
};
const ClearType = (value, type) => {
  if (Array.isArray(value)) return [];
  else if (value === null) return null;
  else {
    switch (typeof value) {
      case 'string':
        return '';
      case 'number':
        return -1;
      case 'boolean':
        return false;
      case 'object':
        if ('id' in value && type) return { id: value.id };
        // else if ('index' in value && type) return { index: value.index };
        else return {};
      default:
        return null;
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
